module.exports = __webpack_public_path__ + "img/item.5c6823f9.png";